import "./CambioPassword.css";
import CambioPasswordPaso1 from "./CambioPasswordPaso1";
import CambioPasswordPaso2 from "./CambioPasswordPaso2";
import CambioPasswordPaso3 from "./CambioPasswordPaso3";
import { useState } from "react";
const CambioPassword = ({ texto, dissmiss }) => {
  const [paso, setPaso] = useState(1);
  // const cambioPaso = (e) => {
  //   setPaso(e);
  // };
  return (
    <>
      <div className="ptur-cambio-password-container">
        {paso === 1 && (
          <CambioPasswordPaso1
            titulo="Generar una nueva contraseña"
            dissmiss={dissmiss}          
          />
        )}
        {paso === 2 && (
          <CambioPasswordPaso2
            titulo="Ingresá el código de seguridad"
            texto={texto}
            dissmiss={dissmiss}
          />
        )}
        {paso === 3 && (
          <CambioPasswordPaso3
            titulo="Creá una contraseña nueva"
            texto={texto}
            dissmiss={dissmiss}
          />
        )}
      </div>
    </>
  );
};

export default CambioPassword;
